import { createContext, useContext, useEffect } from "react";

/** Darkens the universe over `durationMs`; does nothing once it is already dimmed. */
export type Dim = (durationMs: number) => void;

export const DimContext = createContext<Dim>(() => {});

/** The `dim` function, for screens that darken the background at a moment of their own. */
export function useBackgroundDim(): Dim {
  return useContext(DimContext);
}

/** Darkens the background as the screen mounts; instant with the default duration. */
export function useDimBackground(durationMs = 0): void {
  const dim = useBackgroundDim();
  useEffect(() => dim(durationMs), [dim, durationMs]);
}
